export default __webpack_public_path__ + "static/media/fixture2_vertical_bar.8dc343af.png";